module.exports = __webpack_public_path__ + "static/media/MHRP39N1222.69c1780d.svg";